import { render, staticRenderFns } from "./adjustment-cost-details.vue?vue&type=template&id=af12a5d8&scoped=true"
import script from "./adjustment-cost-details.vue?vue&type=script&lang=js"
export * from "./adjustment-cost-details.vue?vue&type=script&lang=js"
import style0 from "./adjustment-cost-details.vue?vue&type=style&index=0&id=af12a5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12a5d8",
  null
  
)

export default component.exports